module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADkSURBVEhL3ZHBCcJQEESDV7ECsQqtQ7AOD7YhWIYH2xAtQ1sQ73rQGfmzhE1WN8SD+OBBZv/sDyTVrzEofp0hXMJTkc+c9WYM1/ACH07OeMZOZ6ZwC29QFx7goshnzdlhlztv4bedwz3U8h3u4Ax6OOMZO+pzl3e0/qczVPEKN3ACP8EOu9zRPu9qoMMVHHHQEe5wV/c0CA86kn6BclbhsxEVswqfjUzxWKyT2XuRLjrSe1Exq/DZiIpZhc9GVMwqfDaiYlbhsxEVswqfjaiYVfhsRMWswmejXv6GDdpKffwLquoJoQr33eZoPvIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-depot/dark/24.png
// module id = 1974
// module chunks = 2